import "./App.css";
import CMSRenderer from "./pages/CMSRenderer/CMSRenderer";

// import { defineCustomElements } from "./dds-library/dist/esm/loader";
// defineCustomElements();

function App({ JSONDATA, LANGUAGE }) {
  console.log("breadbread", JSONDATA);

  return (
    <>
      {JSONDATA ? (
        <CMSRenderer JSONDATA={JSONDATA} LANGUAGE={LANGUAGE} />
      ) : null}
    </>
  );
}

export default App;
